import { useQuery } from '@tanstack/react-query';
import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';
import { CacheConfig } from './consts';

const USERS_PATH = '/api/Users';

export const getUsers = (params) => makeRequest(authFetch.get(`/api/Users${getQueryParams(params)}`));

export const getUser = (id) => makeRequest(authFetch.get(`/api/Users/${id}`));

export const getUsersLookupUrl = (params) => `/api/Users/Lookup${getQueryParams(params)}`;
export const getUsersLookup = (params) => makeRequest(authFetch.get(getUsersLookupUrl(params)))
  .then((data) => data.map((u) => ({ ...u, label: u.displayName, value: u.id })));
export const useGetUsersLookup = (params, opts = {}) => useQuery(
  [getUsersLookupUrl(params)], () => getUsersLookup(params), { ...CacheConfig.forever, ...opts },
);

export const getLcsLookupUrl = (params) => `/api/Users/Lookup/LCs${getQueryParams(params)}`;
export const getLcsLookup = (params) => makeRequest(authFetch.get(getLcsLookupUrl(params))).then((data) => data?.map((x) => ({
  ...x,
  label: x.displayName,
  value: x.id,
})));
export const useGetLcsLookup = (params, opts = {}) => useQuery(
  [getLcsLookupUrl(params)], () => getLcsLookup(params), { ...CacheConfig.forever, ...opts },
);

export const getSalesRepsLookup = (params) => makeRequest(authFetch.get(`/api/Users/Lookup/SalesReps${getQueryParams(params)}`));
export const getForkliftOperatorLookup = (params) => makeRequest(authFetch.get(`/api/Users/Lookup/ForkliftOperators${getQueryParams(params)}`));

// Safety Reps Users
export const getSafetyUserLookupUrl = (params) => `${USERS_PATH}/Lookup/Safety${getQueryParams(params)}`;
export const getSafetyUserLookup = (params) => makeRequest(authFetch.get(getSafetyUserLookupUrl(params)));
export const useGetSafetyUserLookup = (params, opts = {}) => useQuery([getSafetyUserLookupUrl(params)], () => getSafetyUserLookup(params), opts);

export const postUser = (user) => makeRequest(authFetch.put('/api/Users', user));

export const deleteUser = (userId) => makeRequest(authFetch.delete(`/api/Users/${userId}`));

export const restoreUser = (userId) => makeRequest(authFetch.patch(`/api/Users/${userId}/restore`));

export const getRoles = () => makeRequest(authFetch.get('/api/Roles'));

export const getLcGroups = (params) => makeRequest(authFetch.get(`/api/LogisticsCoordinatorGroups${getQueryParams(params)}`));

export const getLcGroupFilter = (onlyWithPros = false) => makeRequest(
  authFetch.get(`/api/Users/LogisticCoordinatorGroupFilter?onlyWithPros=${onlyWithPros}`),
);

export const putLcGroup = (lcGroup) => makeRequest(authFetch.put('/api/LogisticsCoordinatorGroups', lcGroup));

export const deleteLcGroup = (id) => makeRequest(authFetch.delete(`/api/LogisticsCoordinatorGroups/${id}`));

export const restoreLcGroup = (id) => makeRequest(authFetch.patch(`/api/LogisticsCoordinatorGroups/${id}/restore`));

export const getLcGroupAudit = (id, params) => makeRequest(authFetch.get(`/api/LogisticsCoordinatorGroups/${id}/Audits${getQueryParams(params)}`));

export const getUserAudit = (id, params) => makeRequest(authFetch.get(`/api/Users/${id}/Audits${getQueryParams(params)}`));

export const getUserAuditProperties = (id) => makeRequest(authFetch.get(`/api/Users/${id}/Audits/Properties`));

export const getUserAuditUsers = (id) => makeRequest(authFetch.get(`/api/Users/${id}/Audits/Users`));

export const trackDevice = (deviceName) => makeRequest(authFetch.put('/api/Users/TrackDevice', { deviceName }));

export const impersonate = (userId) => makeRequest(authFetch.get(`/api/Users/impersonate/${userId}`));

export const useUsersLookup = (search) => {
  return useQuery({
    queryKey: ['users', 'lookup', search],
    queryFn: () => getUsersLookup({ search }),
    ...CacheConfig.forever,
    enabled: !!search && search.length >= 2,
  });
};

// For initial data loading when we have specific user IDs
export const useUsersLookupById = (ids) => {
  return useQuery({
    queryKey: ['users', 'lookup', { ids }],
    queryFn: () => getUsersLookup({ ids }),
    ...CacheConfig.never,
    enabled: !!ids && ids.length > 0,
  });
};
